module.exports = __webpack_public_path__ + "images/img-3QNyqF3.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/results/1.jpg
// module id = 1954
// module chunks = 0